import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@lightspeed/flame/Text';

import { ReceiptHeader as ReceiptHeaderWrapper } from './Receipt.style';

const ReceiptHeader: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <ReceiptHeaderWrapper data-testid="receipt-header">
      <Text>{t('receipt.checkout')}</Text>
    </ReceiptHeaderWrapper>
  );
};

export default ReceiptHeader;
